<template>
  <div v-if="weeks" class="timeTable">
    <div
      v-for="(day, index) in weeks"
      :key="index"
      class="dayItem">
      <div class="weekday">
        <span class="checkbox">
          <input type="checkbox" :id="`available_day_${day.id}`" v-model="day.available">
          <label :for="`available_day_${day.id}`"></label>
        </span>
        {{ locale[day.id] }}
      </div>
      <div class="times">
        <div
          v-for="(time, idx) in day.time"
          :key="idx"
          class="timeItem"
          :class="{hasDel: day.time.length > 1}"
          @click="openSetAvailableTimeEdit(day.id, idx, time)">
          {{ `${time.from.hh}:${time.from.mm} - ${time.to.hh}:${time.to.mm}` }}
          <button
            v-if="day.time.length > 1"
            type="button"
            class="btnDel"
            @click="delTime($event, day.id, idx)">
          </button>
        </div>
        <!-- 시간 추가 -->
        <button
          v-if="day.time.length <= 2"
          type="button"
          class="btnAdd"
          @click="openSetAvailableTimeEdit(day.id)">
        </button>
        <!-- //시간 추가 -->
      </div>
    </div>
    <SetAvailableTimeEdit
      v-if="timeTarget.day"
      :locale="locale"
      :timeValue="timeTargetData"
      @close="closeSetAvailableTimeEdit"
      @apply="applyTime" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SetAvailableTimeEdit from './SetAvailableTimeEdit'

export default {
  name: 'SetAvailableTime',
  props: [
    'locale',
    'availableTime'
  ],
  components: {
    SetAvailableTimeEdit
  },
  computed: {
    timeTargetData () {
      return this.timeTarget.timeValue || null
    }
  },
  watch: {
    weeks: {
      deep: true,
      handler (data) {
        this.$emit('update', data)
      }
    }
  },
  created () {
    this.weeks = this._.cloneDeep(this.availableTime || this.defaultTable)
    this.$emit('update', this.weeks)
  },
  data () {
    return {
      defaultTable: [
        { id: 'mon', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
        { id: 'tue', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
        { id: 'wed', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
        { id: 'thu', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
        { id: 'fri', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
        { id: 'sat', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
        { id: 'sun', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] }
      ],
      weeks: null,
      timeTarget: {
        day: '',
        timeIndex: null,
        timeValue: null
      }
    }
  },
  methods: {
    openSetAvailableTimeEdit (day, timeIndex, timeValue) {
      this.timeTarget.day = day
      this.timeTarget.timeIndex = timeIndex
      this.timeTarget.timeValue = timeValue
    },
    closeSetAvailableTimeEdit () {
      this.timeTarget.day = ''
      this.timeTarget.timeIndex = null
    },
    delTime (event, day, timeIndex) {
      event.stopPropagation()
      this.weeks = this.weeks.map(x => {
        const isDay = x.id === day
        return isDay ? {
          ...x,
          time: x.time.filter((t, i) => i !== timeIndex)
        } : x
      })
    },
    applyTime (timeValue) {
      const targetDay = this.timeTarget.day
      const timeIndex = this.timeTarget.timeIndex
      const target = this.weeks.find(x => x.id === targetDay)
      const timeTarget = target.time.find((x, i) => i === timeIndex)
      console.log(target, timeTarget, timeIndex)
      if (timeTarget) {
        target.time[timeIndex] = timeValue
      } else {
        target.time.push(timeValue)
      }
      this.closeSetAvailableTimeEdit()
    }
  }
}
</script>

<style lang="scss" scoped>
.timeTable {
  font-size: 14px;
  border: 1px solid $color-lgrey2;
  border-radius: 4px;
  background-color: $color-white;
}
.dayItem {
  display: flex;
  align-items: center;
  padding: 12px;
  & + .dayItem {
    border-top: 1px solid $color-lgrey2;
  }
}
.times {
  flex: 1;
  display: flex;
  .btnAdd {
    align-content: stretch;
    position: relative;
    width: 40px;
    border: 1px dashed $color-lgrey2;
    border-radius: 4px;
    background-color: $bg-default;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/ico_plus.svg') 50% 50% / 16px no-repeat;
      opacity: 0.2;
    }
  }
}
.timeItem {
  position: relative;
  margin-right: 12px;
  padding: 8px 12px;
  border: 1px solid $color-lgrey2;
  border-radius: 4px;
  background-color: $bg-default;
  cursor: pointer;
  &.hasDel {
    padding-right: 36px;
  }
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 12px no-repeat;
      opacity: 0.4;
    }
  }
}
.weekday {
  margin-right: 12px;
  .checkbox {
    margin-right: 4px;
  }
}
</style>
